import { Component, ElementRef, HostBinding, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { DynamicContentModelsByType } from '../dynamic-content.map';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { CanComponentDeactivate, PendingChangesGuard } from '../../../guards/pending-changes.guard';
import { LanguageSelectorComponent } from '../../../components/language-selector/language-selector.component';
import moment from 'moment';
import { TranslateService } from '@services/translate/translate.service';
import { DialogService } from '@services/dialog/dialog.service';
import { OpenReadmeService } from '@services/readme/open-readme.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { PackageService } from '@services/packages/package.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { HttpClient } from '@angular/common/http';
import { PreviewComponent } from '../../../components/preview/preview.component';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';
import { DeeplTranslationService } from '@services/deepl-translation/deepl-translation.service';
import { HelperService } from '@services/helper/helper.service';
import { PackageInstalledWidgetsService } from '@services/packages/package-installed-widgets.service';
import * as _ from 'lodash';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-dynamic-content-edit',
    templateUrl: './dynamic-content-edit.component.html',
    styleUrls: ['./dynamic-content-edit.component.scss'],
    providers: [DynamicContentService, DynamicContentEntranceService, PendingChangesGuard, PackageService, PackageInstalledAppsService, DeeplTranslationService, PackageInstalledWidgetsService],
    standalone: false
})
export class DynamicContentEditComponent implements OnInit, CanComponentDeactivate {

  @ViewChild('titleInput') titleInput: ElementRef;
  @HostBinding('class') public type: string;

  translations: any;
  parentId: string;
  entranceId: string;
  packageId: string;
  languages = [];

  alreadyChecked = false;

  public id = '';
  public copy = false;
  public create = false;

  public isMainNavigation = false;
  public parent: any;
  public composition = null;

  public dynamicContent: any;
  public masterLanguage = 'de';
  public translationEntries = {};
  public availableLanguages = [];

  public pageError = null;

  public dynamicContentHistory = null;
  public myPackage: Models.Package;
  public translationEntriesHistory = null;
  public selectedIndex = 0;
  public isLoading = false;
  public isTranslating = false;
  public pageActions: PageAction[] = [];
  public entrance: Models.DynamicContentEntrance;
  public packageInstalledApp: Models.PackageInstalledApp;
  public packageInstalledWidget: Models.PackageInstalledWidget;
  timestamp = new Date().getTime();
  public contact = { email: null, phone: null }; // for event and restaurants
  public ibexsmartOnly = false;
  public selectedLanguage = 'de';
  public contentIsEmpty = false;
  public isUsedByTranslation = false;
  public categories;
  public parents = [];
  public parentsIds = [];
  appConfig: any;
  private tab;
  iframeVisible = false;
  urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9_-]+\.[a-z]{2,}([\/a-zA-Z0-9#%&=?.:_~-]*)?$/;
  logoutInProcess = false;

  stops = [];
  currentSearchTerm;
  searchTerms = [];

  constructor(
    private snackbar: SnackbarService, private activatedRoute: ActivatedRoute, private dialog: MatDialog, private dialogService: DialogService, private router: Router,
    public contentService: DynamicContentService, public entranceService: DynamicContentEntranceService, private ts: TranslateService, private readme: OpenReadmeService,
    private messengerService: MessengerService, private packageService: PackageService, public http: HttpClient, private contentPipeService: ContentPipeService,
    private translation: DeeplTranslationService, private appService: PackageInstalledAppsService, private widgetService: PackageInstalledWidgetsService
  ) {
    this.initTranslations();
    this.type = this.activatedRoute.snapshot.params['type'];
    this.id = this.activatedRoute.snapshot.params['id'];
    this.create = this.activatedRoute.snapshot.url[0].path === 'create';
    this.packageId = this.activatedRoute.snapshot.queryParams['packageId'];
    if (this.packageId) {
      window['forcePackage'] = this.packageId;
    }
    this.parentId = this.activatedRoute.snapshot.queryParams['parentId'];
    this.entranceId = this.activatedRoute.snapshot.queryParams['entranceId'];
    this.messengerService.$logout.subscribe(res => {
      if (res) {
        this.logoutInProcess = true;
      }
    })
  }

  @HostListener('window:beforeunload')
  @HostListener('window:beforeunload', ['$event'])
  canDeactivateUnload() {
    return this.handleBeforeunload();
  }

  async canDeactivate(): Promise<boolean> {
    return !!(this.handleBeforeunload() || await this.dialogService.confirm(this.translations['system']['general']['pendingChanges']));
  }

  async ngOnInit() {
    this.setFocus();
    this.isLoading = true;
    this.createPageAction();
    this.dynamicContent = null;
    this.parents = [];
    this.parentsIds = [];
    await this.initEntrance();
    await this.getParents();
    this.parents.reverse();
    this.availableLanguages.forEach(lang => this.translationEntries[lang] = {});
    await (this.create ? this.createContent() : this.initContent());
    if (!this.dynamicContent?.content) {
      return;
    }
    this.dynamicContent.content.bookable = true;
  }

  setFocus() {
    setTimeout(() => {
      if (!this.titleInput) return this.setFocus();
      this.titleInput.nativeElement.focus();
    }, 50);
  }

  async initTranslations() {
    this.translations = this.ts.get();
    this.translations['system'] = this.ts.get('system');
  }

  handleBeforeunload() {
    if (!!this.alreadyChecked || !!this.logoutInProcess || !this.dynamicContent) {
      return true;
    }
    this.dynamicContent.content.textContent = this.cleanUpQuillContent(this.dynamicContent.content.textContent);
    this.availableLanguages.filter(lang => !!this.translationEntries?.[lang]?.content).forEach(lang=> {
      this.translationEntries[lang].content.textContent = this.cleanUpQuillContent(this.translationEntries[lang].content.textContent, lang);
    });
    const dynamicContentCopy = this.handleHistoryFields(JSON.parse(JSON.stringify(this.dynamicContent)));
    const dynamicContentHistoryCopy = this.handleHistoryFields(JSON.parse(JSON.stringify(JSON.parse(this.dynamicContentHistory))));
    return !(JSON.stringify(this.translationEntries) !== this.translationEntriesHistory || (JSON.stringify(dynamicContentCopy) !== JSON.stringify(dynamicContentHistoryCopy)));
  }

  handleHistoryFields(element): any {
    if (Array.isArray(element?.content?.contact)) {
      element.content.contact = element.content.contact.reduce((acc, item) => {
        if (item?.value) acc[item.type] = item.value;
        return acc;
      }, {});
    }
    return element;
  }

  async initEntrance() {
    this.entrance = await this.entranceService.get(this.entranceId);
    this.packageInstalledApp = (await this.appService.find(0, 1, { dynamicContentEntranceId: this.entranceId })).data[0];
    if (this.packageInstalledApp?.packageInstalledWidgetId) {
      this.packageInstalledWidget = (await this.widgetService.find(0, 1, { _id: this.packageInstalledApp.packageInstalledWidgetId })).data[0];
    }
    this.myPackage = await this.packageService.get(this.packageId || this.packageInstalledApp.packageId);
    this.appConfig = this.entrance?.config;
    if (this.appConfig?.overwriteBackendType) {
      this.type = this.appConfig?.overwriteBackendType;
    }
    if (!this.messengerService.checkContent(this.entrance._id)) {
      return Promise.reject({ message: 'You are not allowed to view this content' });
    }
    const previewTypes = ['information', 'news', 'restaurant', 'opening-hours', 'event', 'gallery', 'social-media', 'ticker'];
    if (previewTypes.includes(this.entrance?.config?.overwriteContentType || this.entrance?.type)) {
      this.pageActions.push(new PageAction({
        icon: 'visibility', title: 'Preview', translationString: 'general.preview', callback: () => {
          this.openPreview();
        }
      }));
    }
  }

  async getParents() {
    this.availableLanguages = this.myPackage.availableLanguagesCached;
    this.ibexsmartOnly = !!this.myPackage.isNotTouch2015ScreenPackage && !this.myPackage.ibexTouch.enabled;
    this.masterLanguage = this.myPackage.masterLanguageCached || 'de';
    this.parents.push(this.packageInstalledApp?.translations[0]?.appTitle || this.entrance.title);
    if (this.parentId === this.entranceId) {
      this.isMainNavigation = true;
      this.parent = <any>this.entrance;
    } else {
      const dc = await this.contentService.get(this.parentId);
      let parentId = JSON.parse(JSON.stringify(this.parentId));
      while ((await this.contentService.find(0, 1, { children: parentId })).data[0]) {
        const parent = (await this.contentService.find(0, 1, { children: parentId })).data[0];
        parentId = parent._id;
        this.parentsIds.push(parentId);
        this.parents.push(parent.title);
      }
      this.parents.push(dc.title);
      this.parentsIds.push(dc._id);
      this.parent = dc;
      this.isMainNavigation = false;
    }
    this.parents.reverse();
  }

  async initContent() {
    this.categories = await this.getCategories();
    let assigned;
    try {
      assigned = await this.contentService.getAssigned(this.id);
    } catch (err) {
      this.isLoading = false;
      this.pageError = err.message;
      return null;
    }
    if (!assigned) return null;

    console.warn(assigned.content);
    this.dynamicContent = this.initDynamicContentByType(assigned.content);
    this.dynamicContent.content.categories = this.categories.length && (!this.dynamicContent.content?.categories?.length) ? [] : this.dynamicContent.content.categories;
    this.dynamicContent.content.textContent = this.cleanUpQuillContent(this.dynamicContent.content.textContent);
    this.dynamicContent.mediaFiles = this.dynamicContent.mediaFiles || [];
    this.dynamicContent.dataFiles = this.dynamicContent.dataFiles || [];
    this.updatePageAction('language', false, false);
    this.updatePageAction('save&publish', this.dynamicContent.published, false);
    this.languages.push(this.dynamicContent.lang);
    this.dynamicContent.dailyIntervalPublish = this.dynamicContent.dailyIntervalPublish || { start: null, end: null };
    this.handleAdditionalFieldsAfter();

    assigned.translations?.forEach(translation => {
      this.translationEntries[translation.lang] = translation;
      this.languages.push(translation.lang);
    });

    const translationEntriesCopy = JSON.stringify(this.dynamicContent.translationEntries);
    assigned.translations?.forEach(translation => {
      if (!this.dynamicContent?.translationEntries?.includes(translation?._id?.toString()) && !!translation?._id?.toString()?.length) {
        this.dynamicContent.translationEntries.push(translation._id.toString());
      }
    });
    if (translationEntriesCopy !== JSON.stringify(this.dynamicContent.translationEntries)) {
      await this.contentService.update(this.dynamicContent._id, this.dynamicContent);
    }

    if (this.copy) this.copyContent();

    this.checkContent();
    this.isLoading = false;
    setTimeout(() => {
      this.translationEntriesHistory = JSON.stringify(this.translationEntries);
      this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    }, 500);
    this.iframeVisible = !!this.dynamicContent?.content?.iframe;
  }

  initDynamicContentByType(dynamicContent: Models.DynamicContent) {
    if (['gastronomy', 'activity', 'voting', 'webcam', 'important-numbers', 'quiz', 'social-media', 'ticker', 'person', 'event', 'public-transport', 'pinboard'].includes(this.type)) {
      let typeName = JSON.parse(JSON.stringify(this.type)).replace(/[-_]+(.)?/g, (a, c) => (c ? c.toUpperCase() : ''));
      let content: any;
      try {
        content = <any>Models.ModelFactory.createModelInstanceByName('Content' + typeName.charAt(0).toUpperCase() + typeName.slice(1), dynamicContent.content);
      } catch (err) {
        debugger;
      }
      if (this.type === 'event') {
        content.multipleDates = dynamicContent.content.multipleDates;
        content.dates = dynamicContent.content.dates;
      }
      dynamicContent.content = content;
    }
    return dynamicContent;
  }

  async getCategories() {
    const categories = !!this.parent?.categories?.length ? (await this.contentService.find(0, 100, { type: 'category', _id: { $in: this.parent.categories } })).data : [];
    return categories.sort((a, b) => a.order - b.order);
  }

  copyContent() {
    this.dynamicContent = this.removeFieldsForCopy(this.dynamicContent);
    this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    this.availableLanguages.map((lang) => {
      if (this.translationEntries[lang] && this.translationEntries[lang].content) {
        this.translationEntries[lang] = this.removeFieldsForCopy(this.translationEntries[lang]);
      }
    });
    this.translationEntriesHistory = JSON.stringify(this.translationEntries);
  }

  async createContent() {
    const modelMap: { [key: string]: string } = {
      'category': 'ContentGastronomy', 'breaking-news': 'ContentDefault', 'gastronomy': 'ContentGastronomy', 'activity': 'ContentActivity',
      'information': 'ContentDefault', 'webcam': 'ContentWebcam', 'voting': 'ContentVoting', 'opening-hours': 'ContentOpeningHours', 'event': 'ContentEvent',
      'important-numbers': 'ContentImportantNumbers', 'quiz': 'ContentQuiz', 'social-media': 'ContentSocialMedia', 'ticker': 'ContentTicker', 'voucher': 'ContentVoucher',
      'public-transport': 'ContentPublicTransport', 'pinboard': 'ContentPinboard'
    };

    this.categories = await this.getCategories();
    this.dynamicContent = <Models.DynamicContentBase>Models.ModelFactory.createModelInstanceByName(DynamicContentModelsByType.get(this.type));
    this.dynamicContent = this.initDynamicContentByType(this.dynamicContent);
    this.dynamicContent.content.categories = this.categories.length ? [] : this.dynamicContent.content.categories;
    Object.assign(this.dynamicContent, {
      title: '', lang: this.masterLanguage, isMainNavigation: this.isMainNavigation, translationEntries: [],
      dailyIntervalPublish: { start: null, end: null }, masterLanguageEntry: '', type: this.type, mediaFiles: [], dataFiles: []
    });
    this.translationEntriesHistory = JSON.stringify(this.translationEntries);
    this.languages.push(this.dynamicContent.lang);
    this.contentIsEmpty = true;

    if (this.type === 'category') this.dynamicContent.published = true;
    if (this.type === 'breaking-news') this.dynamicContent.content.date = new Date();

    this.handleAdditionalFieldsAfter();

    if (this.type === 'gastronomy') {
      const children = this.parent instanceof Models.DynamicContentEntrance ? await this.contentService.find(0, 100, { _id: { $in: this.parent.children } }) : null;
      const element = children?.data?.length ? children.data.sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime())[0] : null;
      this.dynamicContent.content = <Models.ContentGastronomy>Models.ModelFactory.createModelInstanceByName('ContentGastronomy', element?.content);
    } else if (['activity', 'information', 'webcam', 'voting', 'opening-hours', 'important-numbers', 'quiz', 'social-media', 'voucher', 'event', 'pinboard'].includes(this.type)) {
      this.dynamicContent.content = <Models.ContentDefault>Models.ModelFactory.createModelInstanceByName(modelMap[this.type]);
    }
    this.isLoading = false;

    this.dynamicContent.content['textContent'] = null;
    this.setOrderNumber(this.type === 'category' ? this.parent.categories : this.parent.children);
    if (this.type === 'screensaver') {
      const isScreensaver = !this.appConfig.hideScreensaver
      const isSlideShow = !!this.appConfig?.displaySlideShowWidget;
      const isNavigationSlideshow = !!this.appConfig?.displayBackgroundSlides;

      if ([isScreensaver, isSlideShow, isNavigationSlideshow].filter(Boolean).length === 1) {
        this.dynamicContent.content = { ...this.dynamicContent.content, isScreensaver, isSlideShow, isNavigationSlideshow };
      }
    }

    if (this.type !== 'category' && this.entrance.config?.hasCategories && this.entrance.config?.preSelectFirstCategory && this.categories?.length) {
      this.dynamicContent.content.categories = [this.categories[0]._id];
    }
    setTimeout(() => {
      this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    }, 500);
  }

  updateIframeContent(event: any) {
    this.dynamicContent.iframe = null;
    this.iframeVisible = event.val;
    if (!this.iframeVisible) {
      this.dynamicContent.content.iframe = null;
    }
  }

  checkContent() {
    this.contentIsEmpty = !this.dynamicContent.mediaFiles.length && !this.dynamicContent.dataFiles.length;
    if (this.dynamicContent.content.iframe || (this.dynamicContent.content.textContent && this.dynamicContent.content.textContent.length)) {
      this.contentIsEmpty = false;
    }
    if (!this.contentIsEmpty) {
      this.dynamicContent.isNavigationOnly = false;
    }
    this.isUsedByTranslation = !!Object.values(this.translationEntries).find((item: any) => !!item?.useMasterLanguage);
  }

  async setOrderNumber(ids) {
    this.dynamicContent.order = ids?.length ? (await this.contentService.find(0, 1000, { _id: { $in: ids.filter(Boolean) } })).data.length : 0;
  }

  private async saveByLanguage(language): Promise<any> {
    if (this.dynamicContent.content.multipleDates) {
      this.dynamicContent.content.dates = this.dynamicContent.content.multipleDates[0];
    }

    if (this.type === 'person') {
      this.dynamicContent.title = this.dynamicContent.content.lastname + ' ' + this.dynamicContent.content.firstname;
    }

    if (this.type === 'gastronomy' && this.parent instanceof Models.DynamicContent) {
      this.handleGastronomyItem();
    }

    if (this.dynamicContent.publishEnd) {
      if ((<any>this.dynamicContent.publishEnd).setHours) {
        (<any>this.dynamicContent.publishEnd).setHours(23, 59, 59, 999);
      }
      if ((<any>this.dynamicContent.publishEnd).hours) {
        (<any>this.dynamicContent.publishEnd).hours(23, 59, 59, 999);
      }
    }
    const isTranslation = language !== this.dynamicContent.lang;
    try {
      await this.validateContent(isTranslation, language);
    } catch (err) {
      await this.dialogService.confirm(err.message);
      return Promise.reject(err);
    }
    this.checkContent();
    this.handleAdditionalFields();
    if (isTranslation) {
      this.translationEntries[language].content.textContent = this.cleanUpQuillContent(this.translationEntries[language].content.textContent);
      if (!this.translationEntries[language]._id) {
        return this.addTranslationLanguage(this.translationEntries[language], language);
      } else {
        return this.updateTranslationLanguage(this.translationEntries[language], language);
      }
    } else {
      if (!this.dynamicContent._id) {
        await this.addMasterLanguage();
        this.alreadyChecked = true;
        return await this.router.navigate(['dynamic-content', this.type, this.dynamicContent._id, 'edit'], { queryParams: { parentId: this.parent._id, entranceId: this.entranceId } });
      }
      this.dynamicContent.content.textContent = this.cleanUpQuillContent(this.dynamicContent.content.textContent);
      const res = await this.updateMasterLanguage();
      this.handleAdditionalFieldsAfter();
      return res;
    }
  }

  async save(): Promise<any> {
    for (let lang of this.languages) {
      await this.saveByLanguage(lang);
    }
    this.snackbar.success(this.translations.system.dynamicContent.saved);
    this.languages = [];
    await this.initContent();
    return true;
  }

  private handleGastronomyItem() {
    ['lunch', 'dinner', 'hits'].forEach(key => {
      this.dynamicContent.content[key] = this.dynamicContent.content[key].map(item => {
        item.menuParts = item.menuParts.filter(part => part.length);
        return item;
      }).filter(item => item.menuParts.length || item.title?.length);
    });
    this.dynamicContent.title = HelperService.translateDate(moment(this.dynamicContent.content.date).format('dddd, DD.MM.YYYY'));
  }

  handleAdditionalFieldsAfter() {
    if (!['restaurant', 'event', 'offer', 'opening-hours', 'information', 'voucher'].includes(this.type)) {
      return;
    }
    if (Array.isArray(this.dynamicContent.content.contact)) {
      this.dynamicContent.content.contact.forEach(contact => {
        if (contact.type === 'email') this.contact.email = contact.value;
        if (contact.type === 'phone') this.contact.phone = contact.value;
      });
    } else {
      this.dynamicContent.content.contact = new Models.ContactVariants();
    }

    const { location } = this.dynamicContent.content;
    this.dynamicContent.content.location = {
      ...new Models.Location(), address: location?.address, zip: location?.zip, city: location?.city,
      coordinates: { ...new Models.GeoLocation(), latitude: location?.coordinates?.latitude, longitude: location?.coordinates?.longitude }
    };
    this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
  }

  handleAdditionalFields() {
    if (!['restaurant', 'event', 'offer', 'opening-hours', 'information', 'voucher'].includes(this.type)) {
      return;
    }
    const contactTypes = [{ type: 'email', value: this.contact.email }, { type: 'phone', value: this.contact.phone }];
    this.dynamicContent.content.contact = contactTypes.filter(contact => contact.value && contact.value.length);
    if ('opening-hours' === this.type) {
      this.dynamicContent.content.openingHours = this.dynamicContent.content.openingInfo;
    }
    if ('event' === this.type && !this.dynamicContent.content.repeating) {
      const setDate = (date, time) => {
        if (time) {
          date.hours(parseInt(time.split(':')[0], 10));
          date.minutes(parseInt(time.split(':')[1], 10));
        }
        return date.unix();
      };

      if (!this.dynamicContent.content.validity) {
        this.dynamicContent.content.validity = { };
      }
      if (this.dynamicContent.publishStart) {
        this.dynamicContent.content.validity.start = setDate(moment(this.dynamicContent.publishStart), this.dynamicContent.publishStartTime);
      } else if (this.dynamicContent.content.dates.startDate) {
        this.dynamicContent.content.validity.start = new Date(this.dynamicContent.content.dates.startDate).getTime() / 1000;
      }

      if (this.dynamicContent.publishEnd) {
        this.dynamicContent.content.validity.end = setDate(moment(this.dynamicContent.publishEnd), this.dynamicContent.publishEndTime);
      } else if (this.dynamicContent.content.dates.endDate) {
        this.dynamicContent.content.validity.end = new Date(this.dynamicContent.content.dates.endDate).getTime() / 1000;
      }
    }
  }

  cleanUpQuillContent(content, lang?) {
    content = content ? content.replace(/&nbsp;/gm, ' ') : content;
    return content ? content.replace(/(<p>(<\w*>)*(<br>)*(<\/\w*>)*<\/p>)+$/gm, '') : content;
  }

  async validateContent(isTranslation, language): Promise<any> {
    const isValidUrl = (url: string): boolean => this.urlRegex.test(url);
    const rejectWithMessage = (message: string) => Promise.reject({ message });
    if (!(!!isTranslation ? this.translationEntries[language]?.title : this.dynamicContent.title)) {
      return rejectWithMessage(this.translations['system'].dynamicContent.validation.title);
    }
    if ((!!isTranslation ? this.translationEntries[language]?.content?.iframe : this.dynamicContent.content.iframe)
      && !isValidUrl((!!isTranslation ? this.translationEntries[language]?.content?.iframe : this.dynamicContent.content.iframe).trim())) {
      return rejectWithMessage(this.translations['system'].dynamicContent.validation.inputFieldError);
    }
    if ((!!isTranslation ? ((this.translationEntries[language]?.content?.bookingText || this.translationEntries[language]?.content?.bookingTextScreen) && !this.translationEntries[language]?.content?.bookingUrl) :
      ((this.dynamicContent?.content?.bookingText || this.dynamicContent?.content?.bookingTextScreen) && !this.dynamicContent?.content?.bookingUrl))) {
      return rejectWithMessage(this.translations['system'].dynamicContent.validation.provideUrl);
    }
    if (this.type === 'event' && !this.dynamicContent.content.repeating) {
      if (!this.dynamicContent?.content?.dates?.startDate) {
        return rejectWithMessage(this.translations['system'].dynamicContent.validation.eventStartDate);
      }
    } else if (this.type === 'event' && !!this.dynamicContent.content.repeating) {
      const { repetitionSize: size, repetitionRhythm: rhythm } = this.dynamicContent?.content?.repetition || {};
      if (['day', 'week'].includes(size) && !this.dynamicContent?.content?.repetition?.weekdays?.length) {
        return rejectWithMessage(this.translations['system'].dynamicContent.validation.weekdays);
      }
    }
    if (this.type === 'breaking-news' && !this.dynamicContent.content.date) {
      return rejectWithMessage(this.translations['system'].dynamicContent.validation.date);
    }

    if (this.type === 'voting') {
      if (this.dynamicContent.content.textContent.length > 180) return rejectWithMessage(this.translations.system.dynamicContent.validation.textContentLength);
      if (this.dynamicContent.content.answers.some(a => a.length > 80)) return rejectWithMessage(this.translations.system.dynamicContent.validation.answerLength);

      if (this.dynamicContent.content.type === 'scale') {
        if (!this.dynamicContent.content.scaleIcon) return rejectWithMessage(this.translations.system.dynamicContent.validation.scaleIcon);
        if (this.dynamicContent.content.scaleIcon === 'numeric') {
          const step = parseFloat(this.dynamicContent.content.scaleStep);
          if (!step || isNaN(step)) return rejectWithMessage(this.translations.system.dynamicContent.validation.scaleStep);
          if (step <= 0) return rejectWithMessage(this.translations.system.dynamicContent.validation.scaleStepZero);
        } else {
          if (isNaN(this.dynamicContent.content.scaleMax)) return rejectWithMessage(this.translations.system.dynamicContent.validation.notNumber);
          if (this.dynamicContent.content.scaleMax > 6) return rejectWithMessage(this.translations.system.dynamicContent.validation.scaleMax);
        }
      }
    }

    if (['opening-hours', 'restaurant'].includes(this.type) && this.dynamicContent.content.openingHours) {
      const { regularOpeningHours, exceptionDays } = this.dynamicContent.content.openingHours;
      for (const key in regularOpeningHours) {
        if (regularOpeningHours[key]?.open) {
          for (const { startTime, endTime } of regularOpeningHours[key].times) {
            if (!startTime || !endTime)
              return rejectWithMessage(this.translations.system.dynamicContent.validation.regularOpeningHoursTimes);
          }
        }
      }

      if (exceptionDays) {
        for (let i = 0; i < exceptionDays.length; i++) {
          if (!exceptionDays[i]?.title || !exceptionDays[i]?.date) {
            if (!exceptionDays[i]?.open && !exceptionDays[i]?.title && !exceptionDays[i]?.date) {
              exceptionDays.splice(i--, 1);
              continue;
            }
            return rejectWithMessage(this.translations.system.dynamicContent.validation.exceptionDays);
          }
          if (exceptionDays[i]?.open) {
            for (const { startTime, endTime } of exceptionDays[i]?.times) {
              if (!startTime || !endTime)
                return rejectWithMessage(this.translations.system.dynamicContent.validation.regularOpeningHoursTimes);
            }
          }
        }
      }
    }

    if (this.type === 'quiz' && this.parent instanceof Models.DynamicContent) {
      const res = await this.entranceService.find(0, 1, { children: this.parent._id });
      const minAnswers = res?.data?.[0]?.config?.minAnswers || 2;
      const minRightAnswers = res?.data?.[0]?.config?.minRightAnswers || 1;

      if (!this.dynamicContent.content.answers || this.dynamicContent.content.answers.length < minAnswers) {
        return rejectWithMessage(this.translations['system'].dynamicContent.validation.minAnswers.replace('[placeholder]', minAnswers));
      }

      const rightAnswers = this.dynamicContent.content.answers.filter(answer => answer.isCorrect).length;
      if (rightAnswers < minRightAnswers) {
        return rejectWithMessage(this.translations['system'].dynamicContent.validation.minRightAnswers.replace('[placeholder]', minRightAnswers));
      }
    }

    if (this.type === 'person') {
      if (!this.dynamicContent?.content?.firstname || !this.dynamicContent?.content?.lastname) {
        return rejectWithMessage(this.translations['system'].dynamicContent.validation.person);
      }
    }

    return Promise.resolve(true);
  }

  tabChanged(event) {
    this.selectedLanguage = this.languages[event.index];
  }

  async backPage() {
    if (this.handleBeforeunload() || await this.dialogService.confirm(this.translations['system']['general']['pendingChanges'])) {
      this.alreadyChecked = true;
      const packageId = (Array.isArray(this.packageId) ? this.packageId[0] : this.packageId) || this.packageInstalledApp.packageId;
      const params = !!packageId ? ['dynamic-content', packageId] : ['dynamic-content'];
      await this.router.navigate(params, { queryParams: { parentIds: this.parentsIds.join(','), tab: this.entranceId, item: this.id } });
    }
  }

  async updateMasterLanguage(): Promise<any> {
    this.dynamicContent = await this.contentService.patch(this.dynamicContent._id, this.dynamicContent);
    this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    return this.dynamicContent;
  }

  async updateTranslationLanguage(dynamicContent, lang) {
    this.translationEntries[lang] = await this.contentService.patch(dynamicContent._id, dynamicContent);
    this.translationEntriesHistory = JSON.stringify(this.translationEntries);
    return this.translationEntries;
  }

  async addMasterLanguage() {
    if (this.parent?.config?.addNewItemsOnTop || this.appConfig?.overwriteContentType === 'news') {
      Object.assign(this.dynamicContent.content, { addOnTop: true, parentId: this.parent._id });
    }
    if (this.parent?.config?.addNewItemsOnTop || this.appConfig?.overwriteContentType === 'news') {
      this.dynamicContent.order = 0;
    }
    const result = await this.contentService.create(this.dynamicContent);
    const collection = this.type === 'category' ? 'categories' : 'children';
    this.parent[collection] = this.parent[collection] || [];
    this.parent[collection][this.parent?.config?.addNewItemsOnTop || this.appConfig?.overwriteContentType === 'news' ? 'unshift' : 'push'](result._id);
    if (this.parent?.config?.addNewItemsOnTop || this.appConfig?.overwriteContentType === 'news' && collection === 'children') {
      const items = await this.contentService.find(0, this.parent.children.length, { _id: { $in: this.parent.children } });
      (items?.data || []).forEach(item => this.contentService.patch(item._id, { order: item.order + 1 }))
    }
    await (this.isMainNavigation ? this.entranceService.update(this.parent._id, this.parent) : this.contentService.patch(this.parent._id, { children: this.parent.children }));
    this.dynamicContent = result;
    this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    return result;
  }

  async addTranslationLanguage(dynamicContent, lang) {
    const result = await this.contentService.create(dynamicContent);
    this.dynamicContent.translationEntries.push(result._id);
    await this.contentService.update(this.dynamicContent._id, this.dynamicContent);
    this.translationEntries[lang] = result;
    this.translationEntriesHistory = JSON.stringify(this.translationEntries);
    this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    return result;
  }

  async translateTitleFromMainLanguage(lang: string) {
    this.isTranslating = true;
    this.translationEntries[lang].title = await this.translation.translate(this.dynamicContent.title, lang, this.myPackage._id);
    this.isTranslating = false;
  }

  async changeLanguage() {
    const result = await this.dialog.open(LanguageSelectorComponent, <any>{
      width: '656px', data: { selected: this.languages, available: this.availableLanguages, type: (this.dynamicContent._id ? 'add' : 'change') }
    }).afterClosed().toPromise();
    if (!result) {
      return;
    } else if (result.type === 'add') {
      this.translationEntries[result.lang] = <Models.DynamicContentBase>Models.ModelFactory.createModelInstanceByName(DynamicContentModelsByType.get(this.type));
      this.translationEntries[result.lang] = this.initDynamicContentByType(this.translationEntries[result.lang]);
      this.translationEntries[result.lang].lang = result.lang;
      this.translationEntries[result.lang].masterLanguageEntry = this.dynamicContent._id;
      this.translationEntries[result.lang].type = this.type;
      this.languages.push(result.lang);
      this.selectedIndex = this.languages ? this.languages.length - 1 : 0;
      this.translationEntriesHistory = JSON.stringify(this.translationEntries);
    }
  }

  onEditorChange(event, target, lang?) {
    (!!lang ? this.translationEntries[lang] : this.dynamicContent).content[target] = event;
  }

  updatePageAction(id: string, hidden: boolean, disabled: boolean) {
    this.pageActions.map(pageAction => {
      if (pageAction.options.id === id) {
        pageAction.options.hidden = hidden;
        pageAction.options.disabled = disabled;
      }
    });
  }

  createPageAction() {
    const actions = [
      { icon: 'subdirectory_arrow_left', title: 'Back', translationString: 'general.back', callback: () => this.backPage() },
      { icon: 'save', id: 'save', title: 'Save', translationString: 'general.save', callback: () => this.save() },
      {
        icon: 'save', id: 'save&publish', title: 'Save & Publish', translationString: 'general.save_publish', hidden: false, callback: () => {
          this.dynamicContent.published = true;
          this.save();
        }
      }
    ];
    actions.forEach(action => this.pageActions.push(new PageAction(action)));
  }

  openPreview() {
    if (this.packageId) {
      window['forcePackage'] = this.packageId;
    }
    const content = JSON.parse(JSON.stringify(this.dynamicContent));
    content['app'] = this.packageInstalledApp;
    content['widget'] = this.packageInstalledWidget;
    const data = this.contentPipeService.getTransformedEntry(content, this.entrance);
    this.dialog.open(PreviewComponent, <any>{ width: '95vw', height: '95vh', panelClass: 'preview-modal', data: data });
  }

  removeFieldsForCopy(content: Models.DynamicContent) {
    ['_id', 'created', 'updated', 'daily', 'published', 'publishEnd', 'publishStart', 'publishStartTime', 'publishEndTime', 'monthlyIntervalPublish']
      .forEach(prop => delete content[prop]);
    content.content.dates = new Models.Dates();
    content.content.multipleDates = [new Models.Dates()];
    content.content.validity = new Models.Validity();
    content.dailyIntervalPublish = { start: null, end: null };
    return content;
  }

  public readMe(name, tag) {
    this.readme.openReadMe({ name: name, tag: tag });
  }

  async removeLanguage(lang: string, event: any) {
    event.stopPropagation();
    if (!await this.dialogService.confirm(this.translations['system']['general']['removeTranslation'])) return;
    if (this.translationEntries[lang]._id) await this.contentService.remove(this.translationEntries[lang]._id);
    delete this.translationEntries[lang];
    this.languages = this.languages.filter(language => language !== lang);
    this.translationEntriesHistory = JSON.stringify(this.translationEntries);
    this.snackbar.success(`${lang}${this.translations['system'].dynamicContent.lang_saved}`);
  }

  isQuizMain() {
    return this.parent instanceof Models.DynamicContentEntrance;
  }

  getTitle() {
    if (this.type === 'person') {
      const { firstname: f, lastname: l } = this.dynamicContent?.content || {};
      return f && l ? (this.packageInstalledApp?.detail?.flipNames ? `${l} ${f}` : `${f} ${l}`) : (f || l || 'dynamicContent.create');
    }
    return this.dynamicContent?.title || 'dynamicContent.create';
  }

  addStop() {
    if (!this.dynamicContent?.content?.additionalStops) {
      this.dynamicContent.content.additionalStops = [];
    }
    this.dynamicContent.content.additionalStops.push(new Models.ContentPublicTransportAdditionalStop());
  }

  removeStop(index?: number) {
    this.dynamicContent.content.additionalStops.splice(index, 1);
  }

  searchStop(index?: number) {
    setTimeout(() => {
      let term = index !== undefined ? this.searchTerms[index] : this.currentSearchTerm;
      if (term?.length > 2) {
        return this.http.post(environment.apiBaseURL + '/public-transport/stop', { term }).toPromise().then((res: any) => {
          this.stops = res;
        }).catch(err => {
          console.warn(err);
        });
      }
    }, 50);
  }

  selectStop(stop: any, index?: number) {
    stop = _.clone(_.find(this.stops, { stopId: stop.option.value }));
    if (index !== undefined) {
      this.dynamicContent.content.additionalStops[index].stopId = stop.stopId;
      this.dynamicContent.content.additionalStops[index].stopName = stop.name;
      this.searchTerms[index] = null;
    } else {
      this.dynamicContent.content.stopId = stop.stopId;
      this.dynamicContent.content.stopName = stop.name;
      this.currentSearchTerm = null;
    }
  }
}
